export function classesAdd (){
    const array = [...arguments];

    return array.reduce((previous, item) => {
        if (!previous) return item;
        if (!item) return previous;
        return previous + ' ' + item;
    }, '');
}
